var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#3955a3;}.cls-3{fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visio_48x1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_48",
    "data-name": 48
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23,
    y: 9,
    width: 21,
    height: 30,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,10V38H24V10H43m0-2H24a2,2,0,0,0-2,2V38a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.89,16.74l-4.63-4.63a.37.37,0,0,0-.52,0L32.85,16H28v2h4.85L36,21v8H33V26a1,1,0,0,0-1-1H28v2h3v6H28v2h4a1,1,0,0,0,1-1V31h4a1,1,0,0,0,1-1V21l3.89-3.74A.37.37,0,0,0,41.89,16.74Zm-3.74,2.11L37,20l-1.16-1.16-.69-.69L34,17l1.16-1.16L37,14l3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28,3,3,7.38V40.62L28,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21,16.15,16.26,33l-3.47-.11L8.21,16l3.26,0,2.82,11.78a9.24,9.24,0,0,1,.27,1.69h.06a10.68,10.68,0,0,1,.29-1.72l2.83-11.67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisio);
export default __webpack_public_path__ + "static/media/visio.d4e4145b69617c5518daab4043e04aa2.svg";
export { ForwardRef as ReactComponent };